export default "__VITE_ASSET__ooPPhzih__"